import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationHostTypeService, ReferenceDataLabels } from 'rome-library';
import { take } from 'rxjs/operators';
import { States } from '../../../shared';
import { CookieService } from '../../services/cookie.service';
import { PopUpService } from '../../services/pop-up.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'boi-cookie-warning-banner',
  templateUrl: './cookie-warning-banner.component.html'
})
export class CookieWarningBannerComponent {
  public readonly referenceDataLabels = ReferenceDataLabels;

  constructor(
    private readonly userService: UserService,
    private readonly cookieService: CookieService,
    private readonly applicationHostTypeService: ApplicationHostTypeService,
    private readonly popUpService: PopUpService
  ) {}

  public goToCookiesPage(): void {
    this.popUpService.openContentPopUp(
      `./${this.applicationHostTypeService.getCode()}/${States.CookiesPolicy}`,
      '_blank'
    );
  }

  public acceptCookies(): void {
    this.manageCookies(true);
  }

  public dismissCookies(): void {
    this.manageCookies(false);
  }

  public manageCookies(isAccepted: boolean): void {
    if (!isAccepted) {
      this.cookieService.dismissCookies();
    } else if (this.userService.getUser()?.IsAuthenticated) {
      this.userService
        .acceptCookies()
        .pipe(take(1))
        .subscribe(() => {
          this.cookieService.acceptCookies();
        });
    } else {
      this.cookieService.acceptCookies();
    }
  }
}
